module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABCAYAAAD5PA/NAAAAAXNSR0IArs4c6QAAABBJREFUGFdj9Fq67z8DEgAAJcQCroDTMwAAAAAASUVORK5CYII="